import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { StarterComponent } from './pages/starter.component';
import { PeityModule } from 'src/app/shared/components/charts/peity';
import { SparklineModule } from 'src/app/shared/components/charts/sparkline';

@NgModule({
  declarations: [StarterComponent],
  imports: [BrowserModule, RouterModule, PeityModule, SparklineModule],
  exports: [StarterComponent],
})
export class HomeModule {}
